import API from "shared/services/Api";
import { IAlertResponse } from "shared/types/Alerts";

export const getAlerts = async (
  userId: string,
  idBudget: number | null,
  idPatient: number
): Promise<IAlertResponse> =>
  API.get(`/oc/alert?id=${userId}&idBudget=${idBudget}&idPatient=${idPatient}`);
